import { render, staticRenderFns } from "./RatingProduct.vue?vue&type=template&id=736ec712"
import script from "./RatingProduct.vue?vue&type=script&lang=js"
export * from "./RatingProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports